export default "/images/vendor/flag-icons/flags/4x3/vu.svg?ac5d41948c14810ba607b797e1f9dafd";